import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "./ServiceSections";
import data from "../data.json";

const StatsSection = () => {
  const { homeContent, servicesList } = data;
  // The service count comes from the service list so it never goes stale
  const stats = [
    ...homeContent.stats,
    { value: String(servicesList.length), label: "Specialized Services" },
  ];

  return (
    <section className="py-14 bg-custom-blue">
      <div className="container mx-auto px-4 max-w-6xl grid grid-cols-2 lg:grid-cols-4 gap-8">
        {stats.map((stat, index) => (
          <motion.div
            key={stat.label}
            {...fadeUp}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="text-center"
          >
            <div className="text-4xl md:text-5xl font-bold text-white mb-2">
              {stat.value}
            </div>
            <div className="text-sm md:text-base text-gray-200">{stat.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;
